import React from 'react';
import {FaGithub, FaGg} from 'react-icons/fa';

const ServicesPage = () => {
    const [header] =React.useState({mainHeader: 'SERVICES', subHeading: 'My Services', text:'I provide high quality service for the web development sector with a very good price'}) ;
    const [state] = React.useState([
        {id:1,
             icon: <FaGithub/>,
    heading: 'Web Development',
text: 'Building, creating, and maintaining websites..'},
{id:2,
    icon: <FaGg/>,
heading: 'Web Design',
text: 'Designing full responsive landing pages.'}
    ])
    return (
        <div  className="services">
            <div  className="containerr">
                <div  className="services-header">
                    
                    <div data-aos="zoom-in" className="common">
                    <h3 className="heading">{header.mainHeader}</h3>

                    <h1 className="main-header">
                    {header.subHeading}    
                    </h1>
                    <p className="mainContent">{header.text}.</p>
                    <div className="common-border"></div>
                    </div>
                    <div className="roww bg-main">

                    {state.map( info => (

                        <div data-aos="fade-right" className="coll-6">
                            <div className="services-box">
                                <div className="services-icon">{info.icon}</div>
                                <div className="services-box-header">{info.heading}</div>
                                <div className="services-box-p">
                                   {info.text}
                                </div>

                            </div>
                            
                        </div>
                      
                

                    ))}
                    </div>
                    
                    
                </div>

            </div>
            
        </div>
    );
};

export default ServicesPage;